import { render, staticRenderFns } from "./place-of-birth.vue?vue&type=template&id=7f651644&"
import script from "./place-of-birth.vue?vue&type=script&lang=js&"
export * from "./place-of-birth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports